export default function (context) {
    context.dispatch('set_title', 'Финансы: Счета', {root: true});
    if (context.state.list.length) return;
    let setting = context.state.setting;
    if (setting.defaultFilter) {
        let filter = setting.filters.filter(i => {
            return i.id === setting.defaultFilter;
        })[0];
        if (filter) {
            context.dispatch('form/filter_tab', filter);
        }
    }
}